import { useMutation, useQuery } from 'react-query';
import paths from 'API/paths';
import axiosInstance from 'Services/axiosConfig';
import { Context } from 'Interfaces/FeatureFlip';

const getAllContexts = async (projectId:string) => {
  try {
    const url = paths.getAllContexts();
    const response = await axiosInstance.post(url, {input: {projectId}});
    const contexts = response?.data?.data?.contexts;

    return Array.isArray(contexts) ? contexts as Context[] : [];
  } catch (error) {
    return Promise.reject(error);
  }
  
};



export const useGetAllContexts = () => {
     return useMutation(getAllContexts);
  };